import clsx from 'clsx';
import { ChevronIcon } from '../../assets/icons';
import { PaginationType } from '../../hooks/usePagination';
import Button from '../Button';

type PaginationProps = {
    pagination: PaginationType;
};

const Pagination: React.FC<PaginationProps> = ({ pagination }) => {
    const { currentPage, pages, hasNextPage, hasPrevPage, setPage, nextPage, prevPage } =
        pagination;

    return (
        <div className='pagination'>
            <Button
                variant='transparent'
                className='arrow-button prev'
                onClick={prevPage}
                disabled={!hasPrevPage}
            >
                <ChevronIcon />
            </Button>
            <div className='pages-container'>
                {pages.map((page) => {
                    const isActive = page === currentPage + 1;

                    return (
                        <Button
                            className={clsx('page', {
                                active: isActive,
                                'active-sibling': page - 1 === currentPage - 1,
                            })}
                            variant='transparent'
                            disabled={isActive}
                            onClick={() => setPage(page)}
                            key={page}
                        >
                            {page}
                            <span className='border' />
                        </Button>
                    );
                })}
            </div>
            <Button
                variant='transparent'
                className='arrow-button next'
                onClick={nextPage}
                disabled={!hasNextPage}
            >
                <ChevronIcon />
            </Button>
        </div>
    );
};

export default Pagination;
